import type { ReactNode } from 'react';

export const symbol_place_item: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-440q0-24.75 17.63-42.38Q155.25-680 180-680h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180v440h600v-440H600q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180q24.75 0 42.38 17.62Q840-644.75 840-620v440q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm330-319 68-68q8.5-9 21.25-9t21.75 9q9 9 9 21.5t-9 21.5L501-344q-9 9-21 9t-21-9L339-464q-9-9-8.5-21.5T340-507q9-9 21.5-9t21.5 9l67 68v-491q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v491Z"
		/>
	</svg>
);
